import CodeMirror from 'codemirror'
import 'codemirror/addon/mode/multiplex'
import tinybirdMode from 'editor-languages/lib/tinybird/mode'
import vegaEmbed from 'vega-embed'

import { get } from './utils'
import {
  generate_vegalite_editor_url,
  generate_vegalite_graph
} from './utils/vegalite'

import '../scss/snapshot.scss'

tinybirdMode(CodeMirror)

// Text editors
const sqlEditors = document.getElementsByClassName('sql-editor')
for (let editor of sqlEditors) {
  editor.value = editor.innerText
  CodeMirror.fromTextArea(editor, {
    lineNumbers: false,
    lineWrapping: true,
    matchBrackets: true,
    mime: 'text/x-chsql',
    indentWithTabs: false,
    indentUnit: 2,
    tabSize: 2,
    autoCloseBrackets: true,
    mode: 'Tinybird',
    readOnly: true,
    theme: 'default query-editor',
    cursorBlinkRate: -10
  })
}

// Comments
const comments = document.getElementsByClassName('Transformation-description')
for (let comment of comments) {
  comment.classList.remove('as-color--neutral-40')
  comment.classList.add('as-color--secondary')
}

// Vega buttons
for (let node of window.nodes) {
  if (!!get(['result', 'data'], node)) {
    const vegaGraph = generate_vegalite_graph({
      data: get(['result', 'data', 'data'], node),
      meta: get(['result', 'data', 'meta'], node)
    })

    if (vegaGraph) {
      const chartElement = document.getElementById(node.id + '-chart')
      chartElement.style.display = 'inline-block'
      const vegaElement = document.getElementById(node.id + '-vega')
      vegaElement.href = generate_vegalite_editor_url(vegaGraph)
    }

    var vegaGraphNodeId = 'vega_graph_' + node.id
    var _id = document.getElementById(vegaGraphNodeId)
    // if the node is found, generate it
    if (_id) {
      vegaEmbed('#' + vegaGraphNodeId, vegaGraph)
    }
  }
}
